import { useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { ENGAGEMENT_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportActionRow from '../ReportActionRow';
import ReportList from '../ReportList';

function ReportEngagement({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]: applyExcelFormats(value, ENGAGEMENT_COLUMNS[key]?.style?.numFmt),
          }),
          {},
        ),
      );
    }

    return [];
  }, [processedReport]);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={ENGAGEMENT_COLUMNS}
        headerHeight={36}
        rowKey="consumerId"
      />
    </>
  );
}

export default ReportEngagement;
